import { render, staticRenderFns } from "./ComparativoSugestaoCategoria.vue?vue&type=template&id=04e191f8&scoped=true"
import script from "./ComparativoSugestaoCategoria.vue?vue&type=script&lang=js"
export * from "./ComparativoSugestaoCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e191f8",
  null
  
)

export default component.exports